<template>
  <entity-list-table
    :title="title"
    :data-service="dataService"
    :headers="headers"
    :create-route-name="createRouteName"
    :edit-route-name="editRouteName"
    :show-status-column="false"
    :allow-delete="false"
  >
    <template #item.effectiveDate="{ item }">
      {{ formatEffectiveDate(item.effectiveDate) }}
    </template>
  </entity-list-table>
</template>

<script>
  import EntityListTable from '@/components/ui/crud/EntityListTable.vue'
  import LegalInfoPageDataService from '@/services/api/LegalInfoPageDataService'
  import RouteName from '@/models/enums/RouteName'

  export default {
    components: { EntityListTable },
    data () {
      return {
        title: 'Информация для сайта',
        dataService: LegalInfoPageDataService,
        createRouteName: RouteName.LegalInfoPageCreate,
        editRouteName: RouteName.LegalInfoPageEdit,

        headers: [
          { text: 'ID', value: 'id', align: 'center', sortable: false },
          { text: 'Заголовок', value: 'title', align: 'start', sortable: false },
          { text: 'Заголовок в списке', value: 'listTitle', align: 'start', sortable: false },
          { text: 'Slug', value: 'slug', align: 'start', sortable: false },
          { text: 'Дата вступления в силу', value: 'effectiveDate', align: 'center', sortable: false },
          { text: 'Индекс сортировки', value: 'sortOrder', align: 'center' },
          { text: 'Активна', value: 'isActive', align: 'center', type: 'boolean-check' },
        ],
      }
    },
    methods: {
      formatEffectiveDate (value) {
        if (!value) return '—'
        const date = new Date(value)
        if (Number.isNaN(date.getTime())) return value
        return date.toLocaleDateString('ru-RU', {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        })
      },
    },
  }
</script>
